import { useCallback, useEffect, useState } from 'react';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { IGroup } from 'src/utilities/useSearchHooks';

type UseGetGroupDataReturn = {
  data?: IGroup;
  isLoading?: boolean;
  refetch: () => void;
};

export const useGetGroupData = (
  groupId: string,
  corpId: string
): UseGetGroupDataReturn => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [data, setData] = useState<IGroup>();

  const getGroupInfo = useCallback(async () => {
    try {
      setIsLoading(true);
      const responseData = await sdk.http.get(
        `/corp-admin/${corpId}/groups/${groupId}`
      );

      setData(responseData);
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [groupId, corpId]);

  useEffect(() => {
    getGroupInfo();
  }, [getGroupInfo]);

  return {
    data,
    isLoading,
    refetch: getGroupInfo,
  };
};
